<template>
  <WorkflowStep :step="step" :tab-data="templateTabs" :show-statuses="false" />
</template>

<script>
import toolbarTab from '@/utils/tabs/template-toolbar-tabs-enum';
import templateTabs from '@/utils/tabs/template-tabs-enum';

export default {
  data() {
    return {
      step: toolbarTab.TEMPLATE_INPUTS_TAB,
      templateTabs,
    };
  },
};
</script>

<style lang="scss"></style>
